import { useContext } from "react";
import { FooterContext } from "../providers/footer.context";

export function useFooter() {
  return useContext(FooterContext);
}
